import React from 'react';
import HeroBookDemoCta from './HeroBookDemoCta';
import HeroBrandLogo from './HeroBrandLogo';
import HeroTypewriterTitle from './HeroTypewriterTitle';
import '../hero/HeroSection.css';
import './PatientsHeroSection.css';

const PatientsHeroSection: React.FC = () => (
  <section className="hero">
    <div className="hero-bg" aria-hidden="true">
      <img src="/images/hero_lummo.png" alt="" loading="eager" className="hero-bg-img" />
      <div className="hero-vignette" />
    </div>
    <div className="hero-container">
      <div className="hero-inner">
        <HeroTypewriterTitle text="Patients: The Right Trial Should Find You" />
        <p className="hero-subtitle">Relevant matches, plain-language consent, and real support — hope should not depend on luck or a late-night search.</p>
        <HeroBookDemoCta />
        <HeroBrandLogo />
      </div>
    </div>
    <div className="scroll-indicator" aria-hidden="true">
      <span className="scroll-dot" />
    </div>
  </section>
);
export default PatientsHeroSection;
